const TRANSLATION = {
  common: {
    loading: 'Caricamento',
  },
  i18n: {
    English: 'Inglese',
    Spanish: 'Spagnolo',
    Russian: 'Russo',
    'Portuguese (Brazil)': 'Portoghese (Brasile)',
    Indonesian: 'Indonesiano',
    Czech: 'Ceco',
    German: 'Tedesco',
    French: 'Francese',
    Italian: 'Italiano',
    Dutch: 'Olandese',
    Polish: 'Polacco',
    Vietnamese: 'Vietnamita',
    Turkish: 'Turco',
    Ukrainian: 'Ucraino',
    Chinese: 'Cinese semplificato',
    'Traditional Chinese': 'Cinese tradizionale',
    Japanese: 'Giapponese',
    Korean: 'Coreano',
    Arabic: 'Arabo',
    Persian: 'Persiano',
    Thai: 'Tailandese',
    Hindi: 'Hindi',
    Malay: 'Malay',
    province: {
      Hebei: 'Provincia di Hebei',
      Shanxi: 'Provincia di Shanxi',
      Liaoning: 'Provincia di Liaoning',
      Jilin: 'Provincia di Jilin',
      Heilongjiang: 'Provincia di Heilongjiang',
      Jiangsu: 'Provincia di Jiangsu',
      Zhejiang: 'Provincia di Zhejiang',
      Anhui: 'Provincia di Anhui',
      Fujian: 'Provincia di Fujian',
      Jiangxi: 'Provincia di Jiangxi',
      Shandong: 'Provincia di Shandong',
      Henan: 'Provincia di Henan',
      Hubei: 'Provincia di Hubei',
      Hunan: 'Provincia di Hunan',
      Guangdong: 'Provincia di Guangdong',
      Hainan: 'Provincia di Hainan',
      Sichuan: 'Provincia di Sichuan',
      Guizhou: 'Provincia di Guizhou',
      Yunan: 'Provincia di Yunnan',
      Shaanxi: 'Provincia di Shaanxi',
      Gansu: 'Provincia di Gansu',
      Qinghai: 'Provincia di Qinghai',
      Taiwan: 'Provincia di Taiwan',
      Guangxi: 'Regione Autonoma Zhuang del Guangxi',
      Neimenggu: 'Regione Autonoma della Mongolia Interna',
      Tibet: 'Regione Autonoma del Tibet',
      Ningxia: 'Regione Autonoma Hui del Ningxia',
      Xinjiang: 'Regione Autonoma Uigura dello Xinjiang',
      HongKong: 'Regione Amministrativa Speciale di Hong Kong',
      Macau: 'Regione Amministrativa Speciale di Macao',
      Beijing: 'Municipalità di Pechino',
      Tianjin: 'Municipalità di Tianjin',
      Shanghai: 'Municipalità di Shanghai',
      Chongqing: 'Municipalità di Chongqing',
    },
  },
  pageHeader: {
    product: 'Prodotto',
    tvcTest: 'Test di esperienza TVC',
    tvcEval: 'Valutazione creativa TVC',
    contactUs: 'Contattaci',
    Pricing: 'Prezzi',
    Dashboard: 'Inizia ora',
    signIn: 'Accedi',
    signUp: 'Registrati',
    resourceCenter: 'Blog',
    all: 'Tutti',
    news: 'Notizie',
    insight: 'Insight',
    case: 'Caso',
  },
  productSwitch: {
    common: {
      comingSoon: 'In arrivo',
    },
    modal: {
      heroTitle: 'Seleziona il test che desideri eseguire',
      heroSubtitle:
        'AdEff è sempre pronto a fornirti insight creativi multidimensionali quando ne hai bisogno.',
      remainingTimes: 'Tentativi rimanenti: {{count}}',
      supportedAssets: 'Asset supportati',
      coreMetrics: 'Metriche chiave',
      cognitiveNeuroscienceIndicators: 'Indicatori cognitivo-neurali',
      consumerAttitudeIndicators: 'Indicatori di atteggiamento dei consumatori',
      outputResult: 'Risultato di output',
      dataReport: 'Report dati',
      analysisReport: 'Report di analisi',
      accessBackend: 'Inizia ora',
      tabs: {
        tvc: 'Test creativo orizzontale',
        portrait: 'Test creativo verticale',
      },
      cards: {
        tvcQuick: {
          title: 'Orizzontale-Test rapido',
          descriptionHighlight:
            'Valuta rapidamente le creatività per guidare decisioni basate sui dati',
        },
        tvcBase: {
          title: 'Diagnosi creativa-orizzontale',
          descriptionHighlight:
            'Affina i dettagli creativi con suggerimenti di modifica attuabili',
          value1: 'Creatività TVC/OTV da 10 a 60 sec',
          value2: 'Indicatori cognitivo-neurali',
        },
        tvcSurvey: {
          title: 'InsightPro-orizzontale',
          descriptionHighlight:
            'Analisi creativa multidimensionale con guida strategica all’ottimizzazione',
          value1: 'Creatività TVC/OTV da 10 a 60 sec',
          value2: 'Indicatori cognitivo-neurali',
        },
        portraitQuick: {
          title: 'Verticale-Test rapido',
          descriptionHighlight:
            'Valuta rapidamente le creatività per guidare decisioni basate sui dati',
        },
        portraitBase: {
          title: 'Diagnosi creativa-verticale',
          descriptionHighlight:
            'Affina i dettagli creativi con suggerimenti di modifica attuabili',
          value1: 'Creatività verticali da 5 a 90 sec',
          value2: 'Indicatori cognitivo-neurali',
        },
        portraitSurvey: {
          title: 'InsightPro-verticale',
          descriptionHighlight:
            'Analisi creativa multidimensionale con guida strategica all’ottimizzazione',
          value1: 'Creatività verticali da 5 a 90 sec',
          value2: 'Indicatori cognitivo-neurali',
        },
      },
    },
    hoverPanel: {
      columns: {
        tvc: {
          bannerTitle: 'Test creativo orizzontale',
          assetText: 'Per creatività TVC/OTV da 10 a 60 secondi',
        },
        portrait: {
          bannerTitle: 'Test creativo verticale',
          assetText: 'Per creatività verticali da 5 a 90 secondi',
        },
      },
      items: {
        tvcQuick: {
          description: 'Confronta rapidamente le creatività e decidi',
        },
        tvcBase: {
          title: 'Diagnosi creativa',
          description: 'Ottimizzazione secondo per secondo per affinare le creatività',
        },
        tvcSurvey: {
          title: 'Analisi approfondita',
          description: 'Analisi completa per individuare i problemi chiave',
        },
        portraitBase: {
          title: 'Diagnosi creativa',
          description: 'Ottimizzazione secondo per secondo per affinare le creatività',
        },
        portraitQuick: {
          description: 'Confronta rapidamente le creatività e decidi',
        },
        portraitSurvey: {
          title: 'Analisi approfondita',
          description: 'Analisi completa per individuare i problemi chiave',
        },
      },
    },
  },
  cookieAcceptNotification: {
    title: 'Utilizziamo i cookie',
    desc: 'Utilizziamo cookie necessari per garantire che il nostro sito web funzioni correttamente. Con il tuo consenso, utilizziamo anche cookie analitici per migliorare la tua esperienza utente. Consulta la nostra politica sui cookie nella nostra informativa sulla privacy.',
    btn1: 'Rifiuta tutto',
    btn2: 'Accetta tutto',
    cookiePolicy: 'Politica sui cookie',
  },
  landing: {
    banner: {
      text1: "Guidato dall'IA",
      text2: 'Pubblicità',
      text3: 'Test',
      text4: 'Piattaforma per test creativi e ottimizzazione',
      feature1: 'Decodifica dei contenuti',
      feature2: 'Previsione del feedback',
      feature3: 'Integrazione dei dati',
      feature4: 'Inferenza delle conclusioni',
      btn1: 'Richiedi una demo',
      btn2: 'Crea progetto',
    },
    info: {
      title:
        "Implementazione rapida della previsione dell'efficacia dei contenuti creativi basata sul modello linguistico multimodale a ipergrafo (HMLLM)* per aumentare il ritorno sugli investimenti pubblicitari",
      subTitle:
        '*Questo modello si basa su una vasta gamma di test di neuroscienze del marketing e costruzioni multi-agente',
      detail1: 'Test pubblicitari rapidi',
      detail1Desc:
        "AdEff può ottenere la curva di attenzione del pubblico target, le fluttuazioni emotive e il coinvolgimento con i contenuti creativi in 15 minuti, fornendo report di valutazione dettagliati e linee guida per l'ottimizzazione.",
      detail2: 'Selezione rapida delle migliori creatività',
      detail2Desc:
        "AdEff supporta la misurazione simultanea di più creatività, aiutando i marchi a prendere decisioni rapide. Viene fornita un'analisi comparativa dettagliata.",
      detail3: 'Modifica con un clic, creazione di versioni efficaci e diverse',
      detail3Desc:
        'AdEff supporta la modifica con un clic e può generare rapidamente versioni efficaci e diverse, adatte a vari scenari di comunicazione.',
    },
    advantages: {
      title: 'Vantaggi di AdEff',
      item1Title: 'Risposta rapida',
      item1Desc: 'Rapporti in <tmp>15 minuti</tmp> al massimo.',
      item2Title: 'Modello IA unico',
      item2Desc: 'Unico <tmp>modello IA</tmp> basato sul feedback del pubblico.',
      item3Title: 'Grafici visualizzati',
      item3Desc:
        "<tmp>Grafici visualizzati</tmp> + interpretazione intelligente dell'IA, report di test generati con un clic",
      item4Title: 'Ampia base di dati',
      item4Desc: '<tmp>50.000+</tmp> database di creatività',
      item5Title: 'Team di esperti',
      item5Desc: '<tmp>Team di esperti</tmp> fornisce supporto e guida',
    },
    service: {
      title: 'Opzioni di servizio AdEff',
      desc: "Scegli l'opzione di servizio di cui hai bisogno",
      topTitle: 'Servizio self-service online',
      topRow1: 'Sviluppo autonomo del progetto e conduzione dei test',
      topRow2: "Grafici visualizzati + report di interpretazione dell'IA",
      topRow3: 'Analisi oggettiva degli indicatori neuroscientifici (movimento oculare + EEG)',
      topRow4: 'Test del modello IA unico',
      bottomTitle: 'Servizio del team di esperti',
      bottomRow1: 'Esperti creano progetti e conducono test',
      bottomRow2:
        'Analisi oggettiva degli indicatori neuroscientifici (movimento oculare + EEG), opzionale con indicatori soggettivi',
      bottomRow3: 'Grafici visualizzati + report di interpretazione degli esperti',
      bottomRow4: 'Test del modello IA unico, opzionale con campioni reali',
    },
    footer: {
      title:
        'AdEff si basa sul modello linguistico multimodale a ipergrafo (HMLLM) e costruisce relazioni complesse tra elementi visivi, segnali EEG e dati di tracciamento oculare per testare rapidamente la creatività pubblicitaria',
      email: 'E-mail',
      belongDesc: 'Prodotto di <tmp>Mininglamp Technology</tmp>',
    },
    startBtn: 'Inizia ora',
  },
  contact: { title: 'Contattaci', copy: 'Copia', message: { success: 'Copia riuscita' } },
  pricing: {
    title: "Esperto di test e ottimizzazione creativa guidato dall'IA",
    starter: {
      title: 'Starter',
      desc_1: "Adatto per test monouso, pronto all'uso dopo l'acquisto",
      desc_2: "Adatto per test su piccola scala, pronto all'uso dopo l'acquisto",
      timesDesc: '<strong>{{count}}</strong> volte test',
      timesDesc1: '<strong>{{count}}</strong> volte test',
      discount: 'Sconto 50%',
      originPrice: 'Prezzo originale',
      desc2: 'Modello IA potente basato sul feedback del pubblico',
      desc3: 'Risposta rapida in soli 15 minuti',
      desc4: 'Grafici visualizzati',
      desc5: "Interpretazione intelligente dell'IA",
      desc6: 'Database globale e riferimenti',
      cardDesc1: 'Sconto a tempo limitato, solo {{pricePerTest}}',
      cardDesc2: 'La quota test non scade mai',
    },
    premium: {
      time: 'volte',
    },
    unlimited: {
      title: 'Illimitato',
      cardDesc1: 'A partire da {{pricePerTest}}',
      cardDesc2: 'Quota valida per un anno',
      cardDesc3: 'Benchmark proprietario personalizzato',
      planDesc500: 'Goditi 500 test durante tutto l’anno',
      planDesc1000: 'Goditi 1.000 test durante tutto l’anno',
    },
    benefits: {
      title: 'Perché scegliere AdEff?',
      subtitle: 'Con AdEff puoi ottenere i seguenti vantaggi:',
      expertSupport: 'Supporto e guida del team di esperti',
      moreNeedsTitle: 'Hai altre esigenze di acquisto?',
      customPlanPrefix: 'Supportiamo piani flessibili e personalizzati — contattaci a',
      customPlanSuffix: 'per la tua soluzione esclusiva',
    },
    subscribeBtn: 'Iscriviti ora',
    contactUs: 'Contattaci',
  },
  login: {
    loginText: 'Accedi',
    signUpText: '<tmp>Registrati</tmp> gratuitamente',
    text1: 'Unito al team con successo',
    text1Desc: 'Puoi continuare a testare le pubblicità',
    text2: "Gli utenti si sono uniti all'azienda",
    text3: 'Invito al team scaduto',
    text4: 'Il link di invito al team non è più valido.',
    optionText1: 'Hai già un account?',
    optionText2: 'Non hai un account?',
    alertText1: 'Registrandomi accetto',
    alertText2: 'Accetto',
    termsOfService: 'Termini di servizio',
    privacy: 'Informativa sulla privacy',
    privacyTips: 'Per favore, controlla la casella di accordo prima di registrarti.',
    and: 'e',
    or: 'oppure',
    next: 'Successivo',
    googleLogin: 'Accedi con Google',
    googleSignUp: 'Registrati con Google',
    loginWithEmail: 'Accedi con e-mail',
    signUpWithEmail: 'Registrati con e-mail',
    password: 'Password',
    emailAddress: 'Indirizzo e-mail',
    enterEmail: 'Inserisci il tuo indirizzo e-mail',
    enterPassword: 'Inserisci la tua password',
    confirmPassword: 'Conferma password',
    forgotPassword: 'Password dimenticata?',
    inconsistentPassword: 'Le password non corrispondono',
    verificationCode: 'Codice di verifica',
    emptyVerificationCode: 'Il codice di verifica non può essere vuoto',
    enterVerificationCode: 'Inserisci il codice di verifica',
    sendedVerificationCode: 'Il codice di verifica è stato inviato alla tua e-mail',
    emailOrPasswordNotCorrect: 'E-mail o password non corretti.',
    message: {
      text1: 'Input non valido',
      text2: "L'e-mail è già registrata",
      text3: 'Il codice di verifica non è valido!',
      text4: "Questo account non è collegato all'azienda, per favore ricollegati!",
      text5: 'Inserisci un formato e-mail valido',
      text6: 'La password deve contenere almeno 12 caratteri',
      text7: 'La password deve contenere lettere maiuscole, minuscole e numeri',
      requestLimit: 'Richiesta limitata, per favore riprova più tardi',
    },
  },
  resetPwdPage: {
    submit: 'Invia',
    emailNotFound: 'Per favore verifica la tua e-mail',
    emailHasSent: 'L’e-mail è stata inviata a {{email}}',
    checkYourInbox: 'Verifica la tua e-mail',
    resetYourPassword: 'Resetta la tua password',
    resetLinkHasSent:
      "Un link per resettare la tua password è stato inviato all'indirizzo e-mail associato al tuo account",
    enterYourEmailAddress:
      'Inserisci il tuo indirizzo e-mail e ti invitiamo a resettare la tua password',
    didNotGetEmail: 'Non hai ricevuto un e-mail?',
    tryAgain: 'Riprova',
    goBackToSign: 'Ritorna al login',
    email: 'E-mail',
    enterYourEmail: 'Inserisci il tuo indirizzo e-mail',
    resetPassword: 'Resetta la tua password',
    resetPwdSuccess: 'Password resettata con successo',
    message: {
      resetLinkCodeError: 'Il codice nel link non è valido',
      requestLimit: 'Richiesta limitata, per favore riprova più tardi',
    },
  },
  memberRequestPage: {
    title: 'Verifica richiesta membro',
    subTitle: 'Richiesta da:',
    deny: 'Rifiuta',
    approve: 'Approva',
    teamFull: 'Team pieno',
    yourTeamIsFull:
      'Il tuo team è pieno. Puoi contattarci per ottenere più membri o rimuovere altri membri.',
    manageMembers: 'Gestisci i membri in AdEff',
    requestApproved: 'Richiesta approvata',
    approvedDesc:
      "Hai approvato <tmp>{{name}}</tmp> per unirsi al tuo team, è stata inviata automaticamente un'e-mail di notifica.",
    requestDeclined: 'Richiesta rifiutata',
    declinedDesc:
      "Hai rifiutato <tmp>{{name}}</tmp> per unirsi al tuo team, è stata inviata automaticamente un'e-mail di notifica.",
  },
  infoBindPage: {
    title: "Test pubblicitari guidati dall'IA",
    desc: "Implementazione rapida della previsione dell'efficacia dei contenuti creativi basata sul modello linguistico multimodale a ipergrafo (HMLLM)* per aumentare il ritorno sugli investimenti pubblicitari",
    joinAdEff: 'Unisciti a AdEff e inizia il tuo nuovo viaggio',
    advantages: {
      title1: 'Più potente',
      desc1: 'Modello IA unico basato su un ampio database',
      title2: 'Più economico',
      desc2: 'Solo il 10% del prezzo rispetto ai metodi tradizionali',
      title3: 'Più veloce',
      desc3: 'Rapporto in 15 minuti al massimo',
      title4: 'Più professionale',
      desc4: 'Goditi supporto 24/7 e servizio esperto',
    },
    username: 'Nome utente',
    company: 'Azienda',
    placeOfResidence: 'Nazione/Regione',
    invitationCode: 'Codice di referral',
    createAccountForFree: 'Crea un account gratuitamente',
    refreshStatus: 'Aggiorna stato',
    reapply: 'Rifai richiesta',
    bySigningUp: 'Registrandoti accetti',
    termsOfService: 'Termini di servizio',
    and: 'e',
    privacyPolicy: 'Informativa sulla privacy',
    message: {
      success: "Richiesta di creazione dell'account inviata, attendere!",
      success2: 'Account creato con successo',
      error: "Creazione dell'account fallita, riprova più tardi.",
      accountCreatedDirectly: 'Il tuo account è stato creato direttamente!',
      theRequestHasBeenApprovedAndIsJumpingThePageForYou:
        'La richiesta è stata approvata, la pagina verrà reindirizzata automaticamente.',
      theRequestHasBeenSendAndPleaseBePatient: 'Richiesta inviata, attendere!',
      wrongRouting: 'Errore di routing, la pagina verrà reindirizzata automaticamente.',
      yourRequestHasBeenDeclined:
        'La tua richiesta è stata rifiutata. Puoi ripetere la richiesta per unirti al team o creare un nuovo account senza codice di invito.',
      waitingForAdministratorReview: "In attesa della revisione dell'amministratore",
      thisFieldIsRequired: 'Questo campo è obbligatorio',
      pleaseEnterTheResidence: 'Inserisci il paese',
      invitationCodeDoesNotExist: 'Codice di referral non valido',
      ifYourCompanyHaveBeenJoinedPleaseWriteHere:
        'Se stai utilizzando questo tramite un referral di agente, inserisci il codice di referral',
      pleaseEnterTheUsername: 'Inserisci il nome utente',
      pleaseEnterTheCompanyName: "Inserisci il nome dell'azienda",
      needRegisterAgain: "Errore nell'operazione, per favore registrati di nuovo",
      alreadyBind: "Hai già collegato l'azienda, per favore non collegarla di nuovo",
    },
  },
  knowledgeFormPage: {
    name: 'Il tuo nome',
    email: 'La tua email',
    companyName: "Nome dell'azienda",
    department: 'Dipartimento',
    role: 'Ruolo',
    country: 'Paese',
    province: 'Provincia',
    pleaseEnter: 'Per favore inserisci',
    pleaseSelect: 'Per favore seleziona',
    pleaseEnterTheName: 'Per favore inserisci il tuo nome',
    pleaseEnterTheEmail: 'Per favore inserisci la tua email',
    pleaseEnterValidEmail: 'Per favore inserisci una email valida',
    pleaseEnterTheCompanyName: "Per favore inserisci il nome dell'azienda",
    pleaseSelectTheDepartment: 'Per favore seleziona il dipartimento',
    pleaseSelectTheRole: 'Per favore seleziona il ruolo',
    pleaseSelectTheCountry: 'Per favore seleziona il paese',
    pleaseSelectTheProvince: 'Per favore seleziona la provincia',
    textIsRequired: 'Questo campo è obbligatorio',
    submit: 'Invia',
    download: 'Scarica',
    submitSuccess: 'Invio riuscito',
    downloadSuccess: 'Scarico riuscito',
    title1: 'Per favore compila le tue informazioni per ottenere le risorse',
    title2: 'Seleziona le risorse che desideri scaricare',
  },
  dashboard: {
    pdf: {
      downloadReport: 'Scarica report',
      downloadBtnText: 'Scarica PDF',
      content: 'Contenuto',
      theEnd: 'Fine',
      thankYouForWatching: 'Grazie per aver guardato.',
      pdfProcessing: 'Elaborazione PDF...',
      pdfProcessingDesc:
        'PDF pagine: {{count}}，atteso {{seconds}} secondi, salva dopo, per favore attendi',
      pdfProcessingDesc2:
        'La versione corrente del linguaggio non è tradotta, non può generare PDF',
    },
    ppt: {
      downloadBtnText: 'Scarica PPT',
      pptProcessingDesc: 'File PPT in generazione, attendere prego',
      pptProcessingDesc2:
        'La versione linguistica corrente non è tradotta, impossibile generare PPT',
      pptProcessingDesc3: 'Download del file PPT in corso, si prega di attendere...',
      translateCompleted: 'Traduzione PPT completata',
      exportSuccess: 'Esportazione file PPT riuscita',
      exportFailed: 'Esportazione file PPT non riuscita',
    },
    layout: {
      projectMenuText: 'Progetti di test pubblicitari',
      accountManagementText: 'Gestione account',
      myAccountText: 'Il mio account',
      subscriptionText: 'Abbonamento',
      logout: 'Disconnetti',
      dataDetails: 'Dettagli dati',
      dataAnalysis: 'Analisi dei dati',
      dataOverview: 'Panoramica dati',
      dataComparison: 'Confronto dati',
    },
    systemMessage: {
      title: 'Messaggio di sistema',
      task: 'Compito',
      system: 'Sistema',
      noRelevantContent: 'Nessun contenuto rilevante trovato',
      noMore: 'Nessun altro messaggio',
    },
    projectPage: {
      createProject: 'Crea progetto',
      searchPlaceholder: 'Inserisci il nome del progetto/pubblicità/marca per cercare',
      sortLabel: 'Ordinamento per indice di efficacia pubblicitaria',
      sortPlaceholder: 'Si prega di scegliere il metodo di ordinamento',
      sortOption1: 'Ordine crescente di indice di efficacia',
      sortOption2: 'Ordine decrescente di indice di efficacia',
      filterSort: 'Filtra e ordina',
      filterBenchmarkTitle: 'Filtra benchmark',
      sortTitle: 'Ordina',
      tabAllCreative: 'Tutte le creatività ({{count}})',
      tabGeneralCreative: 'Creatività regolari ({{count}})',
      tabSplashCreative: 'Creatività splash ({{count}})',
      generalCreativeLabel: 'Creatività regolare',
      splashCreativeLabel: 'Creatività splash',
      normTypePlaceholder: 'Si prega di scegliere il tipo di riferimento',
      totalDesc: 'Progetti pubblicitari (totale {{total}})',
      noRelevantContent: 'Nessun contenuto rilevante trovato',
      loadMore: 'Carica altro',
      projectCard: { delete: 'Elimina', reanalyze: 'Rianalizza', download: 'Scarica' },
      delete: 'Elimina',
      cancel: 'Annulla',
      message: {
        deleteTitle: 'Avviso di eliminazione',
        delete:
          'Una volta eliminato questo progetto, tutti i dati associati non saranno più accessibili. Vuoi davvero continuare?',
        delete1:
          "Questo progetto è un progetto di prova gratuito, e la cancellazione non restituirà l'opportunità di prova",
        delete2:
          "Questo progetto non ha ancora iniziato l'analisi. Dopo l'eliminazione, i tuoi crediti di test verranno rimborsati",
        deleteSuccess: 'Eliminazione riuscita!',
        analysisCountNotEnough: 'Numero di test insufficiente, per favore ricarica e riprova.',
        analysisFailed: 'Analisi fallita, per favore riprova più tardi.',
        waitingQuestion:
          "Massimo 3 progetti possono essere analizzati contemporaneamente. Questo progetto è entrato nella coda di attesa e l'analisi inizierà automaticamente a breve.",
        landscapeQuickCompleted: 'Il tuo progetto di test rapido orizzontale è completato.',
        portraitQuickCompleted: 'Il tuo progetto di test rapido verticale è completato.',
        landscapeSurveyCompleted: 'Il tuo progetto orizzontale di insight approfondito è completato.',
        portraitSurveyCompleted: 'Il tuo progetto verticale di insight approfondito è completato.',
      },
    },
    projectCreatePage: {
      createProject: 'Crea progetto',
      basicInformation: 'Informazioni di base',
      projectType: 'Tipo di progetto',
      projectName: 'Nome del progetto',
      categoryType: 'Settore',
      brandName: 'Nome del marchio',
      advertisingInformation: 'Informazioni pubblicitarie',
      adName: 'Nome della pubblicità',
      norm: 'Norma',
      targetMarketNorm: 'Norma del mercato target',
      brandNorm: 'Norma del marchio',
      taGender: 'Genere TA',
      targetMarket: 'Mercato target',
      taAge: 'Età TA',
      next: 'Successivo',
      previous: 'Precedente',
      confirmOrder: 'Conferma ordine',
      estTime: 'Tempo stimato',
      minutes: 'Minuti',
      consumption: 'Consumo di questo ordine',
      testPoint: 'Punti di test',
      remaining: 'Rimanente',
      times: 'volte',
      type: 'Tipo',
      purchase: 'Acquista',
      outputLanguage: 'Lingua di output',
      durationCategory: 'Tipo di creatività',
      durationCategoryDesc: 'Le metriche di analisi variano in base al tipo di creatività; seleziona l’opzione più adatta al tuo contenuto.',
      durationCategoryOptions: {
        tenPlus: 'Creatività generale (10s+)',
        fiveToTen: 'Creatività di apertura (5-10s)',
      },
      adSelection: {
        adCreativeTest: 'Test creativo pubblicitario',
        adCreativeTestDesc:
          'Testa il feedback del pubblico su una singola creatività pubblicitaria e fornisci analisi e raccomandazioni',
        adCreativeSelection: 'Selezione creativa pubblicitaria',
        adCreativeSelectionDesc:
          'Confronta il feedback di più creatività pubblicitarie e scegli in modo completo',
        adCreativeEditing: 'Modifica creativa pubblicitaria',
        adCreativeEditingDesc:
          'Selezione intelligente delle migliori parti della creatività pubblicitaria, generazione automatica di creatività pubblicitarie',
        launchingSoon: 'In arrivo',
      },
      industryCategorySelect: {
        /**----------------------- */
        foodAndBeverageCategory: 'Alimenti e bevande',
        packagedFood: 'Cibo in scatola',
        confectionery: 'Dolci',
        frozenMeals: 'Cibo congelato',
        fastFood: 'Fast food',
        beverage: 'Bevande',
        alcohol: 'Alcolici',
        dairy: 'Latticini',
        grainAndSeasoning: 'Cereali e spezie',
        beverageMixes: 'Bevande miste',
        freshProduce: 'Frutta fresca',
        otherFoodAndBeverage: 'Altri alimenti e bevande',
        /**----------------------- */
        consumerElectronicsCategory: 'Elettronica di consumo',
        mobilePhone: 'Telefono cellulare',
        computer: 'Computer',
        smartDevice: 'Dispositivo intelligente',
        phoneAccessories: 'Accessori cellulari',
        computerAccessories: 'Accessori computer',
        software: 'Software',
        camera: 'Fotocamera',
        officeSupplies: 'Materiali di ufficio',
        otherConsumerElectronics: 'Altri elettronici di consumo',
        /**----------------------- */
        pharmaceuticalsAndHealthCareCategory: 'Farmaci e cura della salute',
        otcMedicine: 'Medicinali OTC',
        prescriptionDrugs: 'Medicinali prescritti',
        healthSupplements: 'Supplementi per la salute',
        pharmaceuticalCompanies: 'Aziende farmaceutiche',
        medicalDevices: 'Dispositivi medici',
        medicalServices: 'Servizi medici',
        pharmacy: 'Farmacia',
        otherPharmaceuticalsAndHealthCare: 'Altri farmaci e cura della salute',
        /**----------------------- */
        beautyAndPersonalCareCategory: 'Bellezza e cura personale',
        hairCare: 'Cura del capello',
        womenSkincare: 'Cura della pelle per donne',
        homeCleaning: 'Limpiezza domestica',
        bodyCare: 'Cura del corpo',
        feminineCare: 'Cura femminile',
        oralCare: 'Cura della bocca',
        menSkincare: 'Cura della pelle per uomini',
        makeup: 'Makeup',
        fragrances: 'Fragranze',
        beautyServices: 'Servizi di bellezza',
        otherBeautyAndPersonalCare: 'Altre bellezza e cura personale',
        /**----------------------- */
        maternalAndInfantProductsCategory: 'Prodotti per madri e bambini',
        babyFood: 'Cibo per bambini',
        babyCareEssentials: 'Cura per bambini',
        babyToys: 'Giocattoli per bambini',
        otherMaternalAndInfantProducts: 'Altri prodotti per madri e bambini',
        /**----------------------- */
        networkAndCommunicationCategory: 'Rete e comunicazione',
        mobileCarriers: 'Operatori di telefonia mobile',
        internetProviders: 'Provider internet',
        telecomEquipment: 'Equipaggiamento di telecomunicazione',
        otherNetworkAndCommunication: 'Altre reti e comunicazioni',
        /**----------------------- */
        travelAndAccommodationCategory: 'Viaggi e alloggi',
        localTourism: 'Turismo locale',
        bookingPlatform: 'Piattaforma di prenotazione',
        hotels: 'Hotel',
        airlines: 'Aerei',
        airport: 'Aeroporto',
        otherTravelAndAccommodation: 'Altri viaggi e alloggi',
        /**----------------------- */
        vehiclesCategory: 'Veicoli',
        motorVehicleProductsAndServices: 'Prodotti e servizi per veicoli',
        carBrands: 'Marche automobilistiche',
        dealerships: 'Concessionarie',
        carFinance: 'Finanziamento auto',
        evCar: 'Auto elettriche',
        motorcycle: 'Motociclette',
        onlineUsedCarMarketplace: 'Mercato auto usati online',
        carRentalPlatform: 'Piattaforma di noleggio auto',
        travelNavigation: 'Navigazione viaggi',
        bicycle: 'Biciclette',
        otherVehicles: 'Altri veicoli',
        /**----------------------- */
        householdAppliancesCategory: 'Elettrodomestici',
        majorAppliances: 'Elettrodomestici principali',
        healthAndPersonalCareAppliances: 'Elettrodomestici per cura personale',
        majorKitchenAndBathAppliances: 'Elettrodomestici principali per cucina e bagno',
        smallKitchenAppliances: 'Elettrodomestici principali per cucina e bagno',
        environmentalAppliances: 'Elettrodomestici principali per cucina e bagno',
        cleaningAppliances: 'Elettrodomestici principali per cucina e bagno',
        otherHouseholdAppliances: 'Altri elettrodomestici',
        /**----------------------- */
        retailAndServiceCategory: 'Retail e servizi',
        onlineRetailEcommerce: 'Retail online/ecommerce',
        departmentStores: 'Deposito',
        lifeServices: 'Servizi di vita',
        retailServicesAndDelivery: 'Servizi di vendita/Consegna',
        supermarkets: 'Supermercati',
        otherRetailAndService: 'Altri servizi di vendita e retail',
        /**----------------------- */
        apparelCategory: 'Abbigliamento e accessori',
        footwear: 'Scarpe',
        clothing: 'Abbigliamento',
        watchesWatchRetail: 'Orologi/Bijoux',
        jewelry: 'Bijoux',
        bags: 'Borse',
        eyewearOpticalStores: 'Occhiali/Optici',
        otherClothingAndAccessories: 'Altri abbigliamento e accessori',
        /**----------------------- */
        homeImprovementAndFurnishingsCategory: 'Impianti e arredamento',
        homeFurnishing: 'Arredamento',
        homeImprovement: 'Impianti',
        otherHomeImprovementAndFurnishings: 'Altri impianti e arredamento',
        /**----------------------- */
        financialAndInsuranceCategory: 'Finanza e assicurazioni',
        bank: 'Banca',
        fintech: 'Fintech',
        investmentAndFinancialServices: 'Servizi finanziari',
        insurance: 'Assicurazioni',
        otherFinancialAndInsurance: 'Altri servizi finanziari e assicurazioni',
        /**----------------------- */
        entertainmentAndLeisureCategory: 'Intrattenimento e divertimento',
        socialApp: 'App sociali',
        toysAndDolls: 'Giocattoli e bambole',
        concerts: 'Concerti',
        events: 'Eventi',
        movies: 'Film',
        themeParks: 'Parchi tematici',
        gambling: 'Giochi di fortuna',
        onlineGaming: 'Giochi online',
        tvChannels: 'Canali TV',
        otherEntertainmentAndLeisure: 'Altri intrattenimento e divertimento',
        /**----------------------- */
        industrialAndAgriculturalCategory: 'Industria e agricoltura',
        industrialSupplies: 'Materiali industriali',
        agriculturalSupplies: 'Materiali agricoli',
        otherIndustrialAndAgricultural: 'Altri materiali industriali e agricoli',
        /**----------------------- */
        petLifeCategory: 'Vita animale',
        petFood: 'Alimenti per animali',
        petSupplies: 'Forniture per animali',
        otherPetLife: 'Altre forniture per animali',
        /**----------------------- */
        educationAndLearningCategory: 'Istruzione e apprendimento',
        onlineLearning: 'Apprendimento online',
        schools: 'Scuole',
        skillCourses: 'Corsi di abilità',
        tutoring: 'Tutor',
        universities: 'Università',
        otherEducationAndLearning: 'Altri prodotti di istruzione e apprendimento',
        /**----------------------- */
        communityAndPublicServiceCategory: 'Comunità e servizi pubblici',
        charityCampaigns: 'Campagne di beneficenza',
        ngoAds: 'Annunci di ONG',
        otherCommunityAndPublicService: 'Altri servizi di comunità e pubblici',
        /**----------------------- */
        otherCategory: 'Altro',
        governmentAdvertising: 'Pubblicità governativa',
        realEstateAdvertising: 'Pubblicità immobiliare',
        otherAdvertising: 'Altre pubblicità',
      },
      genderSelect: {
        male: 'Maschile',
        female: 'Femminile',
        all: 'Tutti',
      },
      targetMarketSelect: {
        China: 'Cina',
        HongKongChina: 'Hong Kong, Cina',
        MacauChina: 'Macao, Cina',
        TaiwanChina: 'Taiwan, Cina',
        Japan: 'Giappone',
        Korea: 'Corea',
        Mongolia: 'Mongolia',
        Singapore: 'Singapore',
        Thailand: 'Thailandia',
        Vietnam: 'Vietnam',
        Malaysia: 'Malesia',
        Philippines: 'Filippine',
        Indonesia: 'Indonesia',
        Cambodia: 'Cambogia',
        Laos: 'Laos',
        India: 'India',
        SaudiArabia: 'Arabia Saudita',
        Turkey: 'Turchia',
        Israel: 'Israele',
        UnitedArabEmirates: 'Emirati Arabi Uniti',
        Qatar: 'Qatar',
        Kuwait: 'Kuwait',
        UnitedKingdom: 'Regno Unito',
        France: 'Francia',
        Germany: 'Germania',
        Netherlands: 'Paesi Bassi',
        Belgium: 'Belgio',
        Austria: 'Austria',
        Italy: 'Italia',
        Spain: 'Spagna',
        Portugal: 'Portogallo',
        Greece: 'Grecia',
        Sweden: 'Svezia',
        Norway: 'Norvegia',
        Finland: 'Finlandia',
        Denmark: 'Danimarca',
        Estonia: 'Estonia',
        Latvia: 'Lettonia',
        Russia: 'Russia',
        Poland: 'Polonia',
        CzechRepublic: 'Repubblica Ceca',
        Hungary: 'Ungheria',
        Romania: 'Romania',
        Bulgaria: 'Bulgaria',
        Slovakia: 'Slovacchia',
        Slovenia: 'Slovenia',
        Ukraine: 'Ucraina',
        UnitedStates: 'Stati Uniti',
        Canada: 'Canada',
        Mexico: 'Messico',
        Brazil: 'Brasile',
        LatinAmerica: 'America Latina',
        Australia: 'Australia',
        NewZealand: 'Nuova Zelanda',
        Other: 'Altro',
      },
      languageSelect: {
        english: 'Inglese',
        chinese: 'Cinese',
        japanese: 'Giapponese',
        korean: 'Coreano',
        french: 'Francese',
        traditionalChinese: 'Cinese tradizionale',
      },
      placeholder: {
        projectName: 'Inserisci il nome del progetto',
        category: 'Seleziona una categoria',
        brandName: 'Inserisci il nome del marchio',
        adName: 'Inserisci il nome della pubblicità',
        norm: 'Seleziona il valore di riferimento',
        taGender: 'Seleziona il genere',
        targetMarket: 'Seleziona il mercato target',
        taAge: "Seleziona l'età",
        lowerLimit: 'Limite inferiore',
        upperLimit: 'Limite superiore',
        outputLanguage: 'Seleziona la lingua di output',
      },
      step: {
        step1: 'Inserimento dati del progetto',
        step2: "Conferma informazioni sull'ordine",
      },
      message: {
        success: 'Creato con successo',
        videoDurationOver60s: 'Durata del video superiore a {{max}} secondi',
        videoDurationLessThan10s: 'Durata del video inferiore a {{min}} secondi',
        videoDurationNeedOver10s: 'La durata del video deve essere superiore a 10 s',
        videoDurationNeedWithin5To10s: 'La durata del video deve essere compresa tra 5 s e 10 s',
        videoDurationNotMatchDurationCategory: 'La durata attuale del video non soddisfa questo tipo di progetto. Carica nuovamente il video e riprova.',
        videoUploadingCannotSwitchDurationCategory: 'Non puoi cambiare tipo di creatività durante il caricamento del video. Attendi il completamento del caricamento.',
        videoFormatOrDurationError: 'Impossibile leggere il formato o la durata del video. Controlla il file video e riprova.',
        videoSizeOver200M: 'Dimensione del video superiore a 256 MB',
        videoLandscape: 'Il video deve essere in formato orizzontale',
        videoPortrait: 'Il video deve essere in formato verticale',
        clickToUploadTestVideo: 'Clicca per caricare il video di test',
        uploadFailed: 'Caricamento fallito, riprova',
        uploadDesc1: 'Supporta file video in formato orizzontale, nei formati MP4, MOV ',
        uploadDescPortrait: 'Supporta file video verticali nei formati MP4, MOV',
        uploadDesc2: 'con limite di dimensione file di 256 MB',
        formNotCompleted: 'Compila tutte le informazioni',
        uploadAdVideo: 'Carica il video pubblicitario',
        inputInvalid: 'Input non valido',
        insufficientTestPoints: 'Punti di test insufficienti, si prega di ricaricare e riprovare.',
        reviewProjectInfo:
          "Controlla attentamente le informazioni del tuo progetto. Una volta confermato l'ordine, non sarà possibile apportare modifiche.",
        waitingDesc:
          "Massimo 3 progetti possono essere analizzati contemporaneamente. Questo progetto è entrato nella coda di attesa e l'analisi inizierà automaticamente a breve.",
        ageRangeInvalid: 'Il range di età supporta solo 20-55',
        normDesc:
          'Benefici illimitati di diritti d’autore, valore di riferimento personalizzato dall’azienda',
      },
    },
    projectDetailPage: {
      testResults: 'Risultati del test',
      share: 'Condividi',
      shareFailed: 'Condivisione non riuscita',
      shareModal: {
        title: 'Condividi',
        desc: 'Copia il testo qui sotto e condividilo sui social media.',
        saveImage: 'Salva immagine',
        copyText: 'Copia testo',
        copySuccess: 'Copiato',
        copyFailed: 'Copia non riuscita',
        textTemplate:
          'Wow! Il mio creativo AI ha superato il {{score}}% dei contenuti simili su AdEff! I dati sono la prova reale! AdEff AI Creative Testing è ora gratuito. Controlla il tuo punteggio su {{hostname}}. Ottieni 5 test gratuiti, ti auguriamo recensioni eccellenti!',
      },
      sharePoster: {
        createdByYou: 'Creato da te',
        scoreTemplate: 'Ha superato il <score>{{score}}</score> delle creatività AIGC',
        statsAt: 'Statistiche al ',
        certification: 'Certificazione Creativa',
        footerText: 'Continua a creare e porta altre opere di qualità!',
      },
      basicInformation: 'Informazioni di base',
      waiting: 'In attesa',
      ongoing: 'In corso',
      failed: 'Fallito',
      tryAgain: 'Riprova',
      videoAnalysisFailed: 'Analisi video fallita',
      message: { projectNotFound: 'Progetto non trovato' },
      primaryAnalysis: 'Prestazione principale',
      detailAnalysis: 'Analisi dettagliata',
      heatmapAnalysis: 'Mappa di calore',
      analysisStepDesc:
        "L'IA ha completato tutte le attività di analisi, le analisi dettagliate sono le seguenti",
      analysisWaitingDesc:
        "Massimo 3 progetti possono essere analizzati contemporaneamente. Questo progetto è entrato nella coda di attesa e l'analisi inizierà automaticamente a breve",
      aiTip: 'Il contenuto del rapporto è generato da AI e è solo per riferimento',
      subAnalysisDescription: {
        adVideoScore: 'Indice di efficacia pubblicitaria',
        adVideoScoreDesc:
          'L’indice di efficacia pubblicitaria è un indicatore integrale dell’efficacia della pubblicità, capace di predire gli effetti a breve e lungo termine delle pubblicità.',
        norm: 'Norma',
        normDesc:
          'Valore di riferimento basato su dati di settore o storici per confrontare le prestazioni pubblicitarie.',
        attentionIndex: 'Indice di attenzione',
        attentionIndexDesc:
          "Misura della concentrazione visiva del pubblico, riflette la capacità di attrarre l'attenzione su azioni ed elementi pubblicitari.",
        emotionIndex: 'Indice emotivo',
        emotionIndexDesc:
          'Misura del grado in cui le emozioni positive vengono attivate nel pubblico, riflette le fluttuazioni emotive immediate suscitate dalla pubblicità.',
        cognitionIndex: 'Indice cognitivo',
        cognitionIndexDesc:
          'Misura del grado in cui il pubblico ha elaborato i contenuti pubblicitari.',
        theGolden3Seconds: "I tre secondi d'oro",
        theGolden3SecondsDesc:
          'I primi 3 secondi della pubblicità sono cruciali per il successo della pubblicità.',
        informationTransmission: 'Momento del messaggio chiave',
        informationTransmissionDesc:
          "Misura della capacità della pubblicità di catturare l'attenzione del pubblico target e stimolare l'interesse.",
        brandRelevance: 'Momento del marchio',
        brandRelevanceDesc:
          "Misura della capacità del momento del marchio di catturare l'attenzione del pubblico target e stimolare l'interesse.",
        interestStimulation: 'Momento di interesse',
        interestStimulationDesc:
          'Momenti chiave che suscitano risonanza emotiva e pensiero attivo nel pubblico.',
        theEnding3Seconds: 'Gli ultimi 3 secondi',
        theEnding3SecondsDesc:
          "Basato sulla legge del picco-fine, gli ultimi 3 secondi della pubblicità sono cruciali per consolidare l'attenzione del pubblico e rafforzare la trasmissione delle informazioni.",
      },
      infoDrawer: {
        basicInformation: 'Informazioni di base',
        advertisingInformation: 'Informazioni pubblicitarie',
        projectName: 'Nome del progetto',
        brandName: 'Nome del marchio',
        category: 'Settore',
        norm: 'Norma del mercato target',
        normLabel: 'Norma',
        brandNorm: 'Norma del marchio',
        adName: 'Nome della pubblicità',
        taGender: 'Genere TA',
        targetMarket: 'Mercato target',
        taAge: 'Età TA',
        ageRange: '{{start}} a {{end}} anni',
        modify: 'Modifica',
        cancel: 'Annulla',
        confirm: 'Conferma',
      },
      videoView: {
        eyeMovementRatio: 'Indice di attenzione',
        cognitiveEngagement: 'Indice cognitivo',
        emotionRecognition: 'Indice emotivo',
        subjectiveResponseCurve: 'Curva di risposta soggettiva',
        realtimeData: 'Dati in tempo reale',
        panoramicData: 'Dati panoramici',
        indexAnalysis: 'Analisi degli indici',
        advantage: 'Vantaggio',
        disadvantage: 'Svantaggio',
        suggestions: 'Suggerimenti',
        adVideoScore: 'Indice di efficacia pubblicitaria',
        norm: 'Norma',
        analysisStepTitle1: 'Decodifica dei contenuti',
        analysisStepTitle2: 'Previsione del feedback',
        analysisStepTitle3: 'Integrazione dei dati',
        analysisStepTitle4: 'Inferenza delle conclusioni',
        analysisStepDesc1:
          'Inizia la decodifica multimodale dei contenuti pubblicitari, decodifica visiva, acustica, testuale e strutturale...',
        analysisStepDesc2:
          'Inizia a prevedere la risposta soggettiva del pubblico basata sui contenuti della pubblicità...',
        analysisStepDesc3:
          'Inizia a integrare i contenuti oggettivi della pubblicità e i dati di risposta soggettiva del pubblico...',
        analysisStepDesc4:
          'Inizia a generare raccomandazioni di valutazione e azione basate sul modello di inferenza...',
        keyResult: 'Risultato chiave',
        videoChart: {
          videoFailed: 'Video playback fallito',
          videoFailedAction:
            'Per favore, aggiorna e riprova. Se il problema persiste dopo diverse aggiornamenti, per favore contattaci per assistenza.',
        },
      },
      storyboardView: {
        summary: 'Riepilogo',
        advantages: 'Vantaggi',
        disadvantages: 'Svantaggi',
        suggestions: 'Suggerimenti',
        keyResult: 'Risultato chiave',
        norm: 'Norma',
        theGolden3Seconds: "I tre secondi d'oro",
        informationTransmission: 'Momento del messaggio chiave',
        brandRelevance: 'Momento del marchio',
        interestStimulation: 'Momento di interesse',
        theEnding3Seconds: 'Gli ultimi 3 secondi',
      },
      heatmapView: {},
    },
    accountPage: {
      email: 'E-mail',
      username: 'Nome utente',
      password: 'Password',
      setPasswordToEnableEmailLogin: "Imposta la password per abilitare l'accesso tramite e-mail",
      uid: 'UID',
      contactAndReceiveNotifications: 'Contattaci e ricevi notifiche',
      receiveEmailsAboutAdeffLatestUpdatesWithThisEmail:
        'Ricevi e-mail sugli ultimi aggiornamenti di AdEff a questo indirizzo e-mail.',
      myWorkspace: 'Il mio spazio di lavoro',
      newRequest: 'Nuova richiesta',
      invitationCode: 'Codice di referral',
      userName: 'Nome utente',
      invitationCodeDesc:
        'Ogni team ha un codice di invito unico, che aiuta i nuovi utenti a richiedere di unirsi al team durante la registrazione',
      table: {
        userName: 'Nome utente',
        email: 'E-mail',
        operation: 'Operazione',
        admin: 'Amministratore',
        remove: 'Rimuovi',
        deny: 'Rifiuta',
        approve: 'Approva',
      },
      message: {
        yourTeamIsFull:
          'Il tuo team è pieno. Puoi contattarci per ottenere più membri o rimuovere altri membri.',
        invitationLinkSent: 'Il link di invito è stato inviato a questo indirizzo e-mail!',
        removeReminder: 'Avviso di rimozione',
        remove: 'Rimuovi',
        removeMember:
          'Dopo aver rimosso il membro, i contenuti creati da questo membro rimarranno. Vuoi davvero rimuovere il membro?',
        removeMemberSuccess: 'Membro rimosso con successo!',
        ok: 'OK',
        contactUs: 'Contattaci',
        applicationProcessedSuccessfully: 'Richiesta elaborata con successo!',
        notificationSettingsTurnedOn: 'Impostazioni di notifica attivate',
        notificationSettingsTurnedOff: 'Impostazioni di notifica disattivate',
        setPassword: 'Imposta password',
        passwordConfirm: 'Conferma',
        passwordCancel: 'Annulla',
        oldPassword: 'Vecchia password',
        newPassword: 'Nuova password',
        pleaseEnterTheOldPassword: 'Inserisci la vecchia password',
        pleaseEnterTheNewPassword: 'Inserisci la nuova password',
        incorrectEntryOfOriginalPassword: 'Inserimento della password originale errato',
        passwordUpdatedSuccessfully: 'Password aggiornata con successo',
        changeUsername: 'Cambia nome utente',
        confirm: 'Conferma',
        cancel: 'Annulla',
        username: 'Nome utente',
        pleaseEnterTheNewUsername: 'Inserisci il nuovo nome utente',
        userNameUpdatedSuccessfully: 'Nome utente aggiornato con successo',
        addMemberToWorkspace: 'Aggiungi nuovo membro allo spazio di lavoro',
        notAdminOperate: 'Non amministratore, non può operare',
        emailAddress: 'Indirizzo e-mail',
        send: 'Invia',
        willSendAnInvitationEmailToThisAddressForConfirmation:
          "Invieremo un'e-mail di invito a questo indirizzo per conferma.",
        workspaceMemberShip: 'Membri dello spazio di lavoro',
        forMoreMembership: 'Per ulteriori membri',
        reachedTheCeiling: 'Hai raggiunto il limite massimo.',
        incorrectMailboxFormat: 'Formato e-mail non valido',
        member: 'Membro',
        changeCorpNameTitle: 'Cambia nome azienda',
        changeCorpNameLabel: 'Nome azienda',
        pleaseEnterTheCorpName: 'Inserisci il nome azienda',
        changeCorpNameSuccess: 'Nome azienda cambiato con successo',
        changeCorpNameFailed: 'Cambio nome azienda fallito',
        noPermission: 'Non hai permesso di cambiare il nome azienda',
      },
    },
    subscriptionPage: {
      currentPlan: 'Piano attuale',
      getInvoice: 'Ottieni la tua fattura',
      remainingTimes: 'Tempi rimanenti',
      purchaseMore: 'Acquista di più',
      contactUs: 'Contattaci',
      teamPlan: 'Servizio del team di esperti',
      unlimited: 'Illimitato',
      dueDate: 'Data di scadenza',
      table: {
        usageRecords: 'Registri di utilizzo',
        date: 'Data',
        projectName: 'Nome del progetto',
        projectType: 'Tipo di progetto',
        usageCount: 'volte',
        userName: 'Nome utente',
        noRelevantContent: 'Nessun contenuto rilevante trovato',
      },
    },
    portraitDataDetailPage: {
      regularCreativeProject: 'Progetto creatività regolare',
      regularCreative: 'Creatività regolare',
      splashCreativeProject: 'Progetto creatività splash',
      splashCreative: 'Creatività splash',
      projects: 'Progetti',
      localNorm: 'Benchmark locale',
      projectPassRate: 'Tasso di superamento del progetto',
      passRate: 'Tasso di superamento',
    },
    dataDetailPage: {
      baseData: 'Dati di base',
      totalProjects: 'Totale progetti',
      totalProjectsDesc:
        'Numero totale di progetti validi che partecipano all’analisi dell’efficacia pubblicitaria.',
      // averageEffectivenessIndex: 'Indice di efficacia medio',
      // averageEffectivenessIndexDesc:
      // 'Media degli indici di efficacia pubblicitaria di tutti i progetti validi.',
      localNormProjects: 'Progetti di riferimento locale',
      brandNormProjects: 'Progetti di riferimento del marchio',
      normProject: 'Progetto di riferimento del mercato target',
      brandNormProject: 'Progetto di riferimento del marchio',
      localNorm: 'Valore di riferimento locale',
      localNormDesc:
        'Valore medio dell’indice di efficacia pubblicitaria dei progetti validi che hanno come mercato target il tuo paese.',
      norm: 'Valore di riferimento',
      brandNorm: 'Valore di riferimento del marchio',
      brandNormDesc:
        'Valore medio dell’indice di efficacia pubblicitaria dei progetti validi che hanno come mercato target il valore di riferimento del marchio.',
      localProjectPassRate: 'Tasso di successo dei progetti locali',
      projectPassRate: 'Tasso di successo dei progetti',
      brandProjectPassRate: 'Tasso di successo dei progetti del marchio',
      projectPassRateDesc:
        'Proporzione di progetti il cui indice di efficacia pubblicitaria supera il valore di riferimento rispetto al totale dei progetti valutati.',
      advertisingEffectivenessIndexDistribution:
        'Distribuzione dell’indice di efficacia pubblicitaria',
      advertisingEffectivenessIndexDistributionDesc:
        'Proporzione di progetti in diverse gamme dell’indice di efficacia pubblicitaria.',
      item: 'elementi',
    },
    dataComparisonPage: {
      createCompare: 'Nuovo confronto',
      createCompareDesc: 'Seleziona più progetti da confrontare, fino a 10 progetti.',
      startCompare: 'Avvia confronto',
      compareReport: 'Report di confronto',
      searchPlaceholder: 'Cerca nome del report di confronto',
      emptyText: 'Non ci sono ancora report di confronto. Seleziona prima i progetti da confrontare.',
      searchEmptyText: 'Nessun report di confronto trovato.',
      deleteTitle: 'Elimina report di confronto',
      deleteConfirm: 'Vuoi davvero eliminare questo report di confronto? L’azione non può essere annullata.',
      projectCount: '{{count}} progetti',
    },
    dataComparisonStartPage: {
      back: 'Indietro',
      basicInfo: 'Informazioni di base',
      reportName: 'Nome report:',
      reportNamePlaceholder: 'Inserisci il nome del report di confronto',
      norm: 'Benchmark:',
      normPlaceholder: 'Seleziona benchmark',
      normTip: 'Seleziona il benchmark usato per confrontare i progetti',
      selectProject: 'Seleziona progetti',
      searchPlaceholder: 'Cerca per progetto/annuncio/brand',
      selectedCountPrefix: ' Selezionati ',
      selectedCountSuffix: ' progetti, fino a {{max}} progetti',
      startCompare: 'Avvia confronto',
      save: 'Salva',
      cancel: 'Annulla',
      maxSelectedWarning: 'Puoi selezionare fino a 10 progetti',
      reportNameRequired: 'Inserisci il nome del report di confronto',
      normRequired: 'Seleziona benchmark',
      projectRequired: 'Seleziona progetti',
    },
    dataComparisonInfoPage: {
      defaultReportName: 'Nome del report di confronto',
      reportNotFound: 'Report non trovato',
      back: 'Indietro',
      modify: 'Modifica',
      deletedProjectTip: 'I seguenti progetti: {{names}} sono stati eliminati. Dopo la conferma, il report di confronto verrà aggiornato e i progetti eliminati saranno rimossi.',
      confirmDeletedProjects: 'Conferma',
      metricScore: 'Punteggio indicatore',
      tabDimension: 'Cinque dimensioni',
      tabMoment: 'Momento chiave',
      tabAttitude: 'Atteggiamento del consumatore',
      adeffScore: 'Punteggio AdEff',
      brandName: 'Nome brand',
      projectName: 'Nome progetto',
      industry: 'Settore',
      targetMarket: 'Mercato target',
      gender: 'Genere TA',
      age: 'Età TA',
      adProject: 'Progetto pubblicitario',
      normLabel: 'Benchmark',
      mixedCreativeBenchmarkTip: 'Nessun benchmark è disponibile quando si confrontano simultaneamente creatività generali e creatività splash.',
      emptyProject: 'Seleziona progetti per visualizzare i dati di confronto',
      viewProjectDetail: 'Visualizza dettagli progetto',
      listSeparator: ', ',
      metricLabels: {
        attention: 'Forza di attenzione',
        infectivity: 'Forza emotiva',
        delivery: 'Forza del messaggio',
        brand: 'Forza del brand',
        persuasion: 'Forza persuasiva',
        gazeRecognition: 'Riconoscimento dello sguardo',
        emotionRecognition: 'Riconoscimento delle emozioni',
        engagementRecognition: 'Riconoscimento del coinvolgimento',
        goldenSeconds: 'I tre secondi d\'oro',
        brandMoment: 'Momento del marchio',
        productMoment: 'Momento di interesse',
        messageMoment: 'Momento del messaggio chiave',
        endingSeconds: 'Gli ultimi 3 secondi',
        likeability: 'Gradimento',
        newInformation: 'Nuove informazioni',
        messageRelevance: 'Rilevanza del messaggio',
        comprehension: 'Comprensione',
        credibility: 'Credibilità',
        brandLinkage: 'Connessione al brand',
        uniqueness: 'Unicità',
        learnMoreIntent: 'Disponibilità a saperne di più',
        purchaseIntent: 'Intenzione di acquisto',
        recommendIntent: 'Condivisibilità',
        brandLikeabilityLift: 'Aumento del gradimento del brand',
        purchaseIntentionLift: 'Aumento dell’intenzione di acquisto',
        attentionIndex: 'Indice di attenzione',
        emotionIndex: 'Indice emotivo',
        cognitionIndex: 'Indice cognitivo',
      },
    },
    experience: {
      projectDetailPage: {
        analysisCompleted: 'Il tuo progetto di valutazione creativa TVC è completato.',
        title: {
          text1: 'Test della creatività pubblicitaria',
          text2: 'Report del test',
        },
        flowAnalysis: {
          desc1: 'AdEff sta scomponendo il tuo video pubblicitario',
          desc2: 'Scomposizione del video completata',
          desc3: 'Analisi dell’attenzione visiva dei consumatori',
          desc4: 'Analisi del focus visivo in base ai profili dei consumatori',
          desc5: 'Generazione della heatmap dell’attenzione',
          desc6: 'Heatmap dinamica generata',
          desc7: 'Misurazione delle risposte cognitivo-neurali',
          desc8: 'Monitoraggio di sguardo, emozione e coinvolgimento secondo per secondo',
          desc9: 'Generazione della curva di risposta neurale',
          desc10: 'Curva di risposta neurale generata',
          desc11: 'Analisi delle prestazioni nei momenti chiave',
          desc12: 'Misurazione delle risposte cognitivo-neurali durante: 3 secondi d’oro, momento del messaggio, momento del brand, picco di interesse e ultimi 3 secondi',
          desc13: 'Sintesi delle metriche dei momenti chiave',
          desc14: 'Analisi dei momenti chiave completata',
          desc15: 'Analisi degli atteggiamenti dei consumatori',
          desc16: 'Analisi degli atteggiamenti verso brand, prodotto e contenuto',
          desc17: 'Sintesi delle metriche di atteggiamento',
          desc18: 'Metriche di atteggiamento completate',
          desc19: 'Generazione dei punteggi delle cinque leve',
          desc20: 'Punteggi delle cinque leve pronti',
          desc21: 'Analisi completata! Il report sulle prestazioni dell’annuncio è pronto',
          terminology: {
            thumbExpand: 'Espandi miniature',
            thumbCollapse: 'Comprimi miniature',
            gazeRecognition: 'Riconoscimento dello sguardo',
            gazeRecognitionDesc: 'Misura la concentrazione dell’attenzione visiva e indica quanto efficacemente gli elementi dell’annuncio catturano il focus dello spettatore.',
            emotionRecognition: 'Riconoscimento delle emozioni',
            emotionRecognitionDesc: 'Quantifica le emozioni positive e le risposte affettive immediate generate dall’annuncio.',
            engagementRecognition: 'Riconoscimento del coinvolgimento',
            engagementRecognitionDesc: 'Misura immersione e coinvolgimento, riflettendo l’investimento mentale nel contenuto dell’annuncio.',
            theGolden3Seconds: 'Prestazioni dei 3 secondi d’oro',
            theGolden3SecondsDesc: 'Valuta l’efficacia del contenuto dell’annuncio nei primi 3 secondi.',
            keyMessage: 'Prestazioni del messaggio chiave',
            keyMessageDesc: 'Misura la capacità dei momenti informativi dell’annuncio di catturare attenzione e stimolare interesse.',
            brand: 'Prestazioni del brand',
            brandDesc: 'Valuta la cattura dell’attenzione specifica del brand e l’efficacia del coinvolgimento.',
            interest: 'Picco di interesse',
            interestDesc: 'Identifica i picchi di contenuto che generano risonanza emotiva e alto coinvolgimento.',
            ending3Seconds: 'Prestazioni degli ultimi 3 secondi',
            ending3SecondsDesc: 'Valuta l’efficacia del contenuto dell’annuncio negli ultimi 3 secondi.',
            score: 'Punteggio',
            benchmark: 'Benchmark',
            metrics: 'Metriche',
            attitudePart: {
              attitudeMetrics: 'Metriche di atteggiamento',
              liking: 'Gradimento',
              likingDesc: 'Misura l’atteggiamento soggettivo del pubblico e il grado complessivo di gradimento verso l’annuncio.',
              newInformation: 'Nuove informazioni',
              newInformationDesc: 'Misura se il pubblico ritiene di aver ottenuto dall’annuncio informazioni preziose e prima sconosciute su brand o prodotto.',
              messageRelevance: 'Rilevanza del messaggio',
              messageRelevanceDesc: 'Misura quanto il pubblico percepisce le informazioni trasmesse dall’annuncio come direttamente rilevanti per sé.',
              comprehension: 'Comprensione',
              comprehensionDesc: 'Misura se il messaggio chiave dell’annuncio è stato compreso in modo chiaro, accurato e senza sforzo.',
              credibility: 'Credibilità',
              credibilityDesc: 'Misura quanto il pubblico ritiene vere, affidabili e degne di fiducia le informazioni comunicate.',
              brandLinkage: 'Connessione al brand',
              brandLinkageDesc: 'Misura la capacità del pubblico di associare correttamente e fortemente l’annuncio al brand specifico.',
              uniqueness: 'Unicità',
              uniquenessDesc: 'Misura se l’annuncio crea una percezione chiara dell’unicità distintiva e preziosa del brand rispetto ai concorrenti.',
              willing: 'Disponibilità a saperne di più',
              willingDesc: 'Misura la probabilità soggettiva che il pubblico intraprenda azioni per conoscere meglio brand o prodotto dopo la visione.',
              purchase: 'Intenzione di acquisto',
              purchaseDesc: 'Misura la probabilità soggettiva che il pubblico consideri di scegliere o acquistare il prodotto del brand in futuro.',
              share: 'Condivisibilità',
              shareDesc: 'Misura la probabilità soggettiva che il pubblico condivida attivamente l’annuncio o le informazioni del brand con altri.',
              brandLikeLift: 'Aumento del gradimento del brand',
              brandLikeLiftDesc: 'Misura direzione e grado del cambiamento nel gradimento complessivo verso brand o prodotto dopo l’esposizione all’annuncio.',
              purchaseIntentLift: 'Aumento dell’intenzione di acquisto',
              purchaseIntentLiftDesc: 'Misura direzione e grado del cambiamento nella disponibilità a considerare l’acquisto del prodotto del brand dopo l’esposizione.',
            },
            dimensionPart: {
              forceDrives: 'Leve di forza',
              attension: 'Attenzione',
              emotionalImpact: 'Impatto emotivo',
              messageClarity: 'Chiarezza del messaggio',
              brandPower: 'Forza del brand',
              persuasion: 'Persuasione',
              attentionForce: 'Forza di attenzione',
              attentionForceDesc: 'Misura la capacità dell’annuncio di catturare e mantenere l’attenzione visiva e uditiva del pubblico.',
              emotionalForce: 'Forza emotiva',
              emotionalForceDesc: 'Misura l’intensità della risonanza emotiva immediata e istintiva evocata dal contenuto dell’annuncio.',
              messageForce: 'Forza del messaggio',
              messageForceDesc: 'Misura l’efficacia con cui il messaggio centrale dell’annuncio viene identificato, compreso e ricordato dal pubblico target.',
              brandForce: 'Forza del brand',
              brandForceDesc: 'Misura l’efficacia dell’annuncio nel rafforzare l’identità del brand, aumentare la preferenza e costruire una forte connessione di marca.',
              persuasiveForce: 'Forza persuasiva',
              persuasiveForceDesc: 'Misura la capacità finale dell’annuncio di cambiare percezioni e stimolare intenzioni comportamentali.',
            },
            result: {
              results: 'Risultati',
              pass: 'Superato',
              notPass: 'Non superato',
              adeffScore: 'Punteggio AdEff',
              adeffScoreDesc: 'Il punteggio AdEff misura l’efficacia complessiva degli annunci.',
              benchmarkDesc: 'Il punteggio AdEff medio di tutti gli annunci caricati nel paese o nella regione dell’annuncio viene usato per confrontarne le prestazioni.',
            },
          },
        },
        pptAnalysis: {
          emptyState: {
            waiting: 'In attesa...',
            description: 'Generazione del report del test...',
          },
          generating: 'Generazione...',
          freeTrialLockText1:
            'In modalità prova non è possibile visualizzare in anteprima o scaricare il report completo.',
          freeTrialLockText2: 'Sottoscrivi per sbloccarlo.',
        },
      },
    },
  },
  professor: {
    account: 'Account',
    password: 'Password',
    login: 'Login',
    expertReviews: 'Recensioni degli esperti',
    adVideoScore: 'Indice di efficacia pubblicitaria',
    subjectiveResponseCurve: 'Curva di risposta soggettiva',
    indexAnalysis: 'Analisi degli indici',
    keyResult: 'Risultato chiave',
    theGolden3Seconds: "I tre secondi d'oro",
    informationTransmission: 'Momento del messaggio chiave',
    brandRelevance: 'Momento del marchio',
    interestStimulation: 'Momento di interesse',
    theEnding3Seconds: 'Gli ultimi 3 secondi',
    heatMap: 'Mappa di calore',
    suggestion: 'Suggerimenti',
    suggestion1: 'Suggerimento',
    submit: 'Invia',
    next: 'Avanti',
    summary: 'Riepilogo',
    advantages: 'Vantaggi',
    disadvantages: 'Svantaggi',
    option1: 'Atteso',
    option2: 'Non atteso',
    resultJudgment: 'Valutazione',
    placeholder: 'Inserisci una suggerimento',
    waitRateCount: 'Numero di annunci da valutare',
    unfinishedTitle: 'Notifica',
    unfinishedRate: 'La valutazione contiene elementi incompleti',
    unfinishedConfirm: 'Continua la valutazione',
    unfinishedCancel: 'Esci',
    message: {
      submitSuccess: 'Grazie per la tua valutazione',
      submitSuccess1:
        'Hai completato la valutazione di questo progetto, grazie per la tua valutazione',
      loginSuccess: 'Login effettuato con successo',
      rateUnfinished:
        'Non hai ancora valutato il contenuto attuale, per favore compila prima di passare alla domanda successiva',
      rateLocation: 'Ti abbiamo automaticamente indirizzato al contenuto non valutato',
    },
  },
  modals: {
    freeTrialModal: {
      title: 'Richiedi una prova',
      title1: 'Prova gratuita',
      trial: 'Prova',
      hiddenBoxText1: 'Sono stati rilevati diversi vantaggi, svantaggi e suggerimenti',
      hiddenBoxText2: 'Sottoscrivi per ottenere il rapporto completo',
      hiddenBoxBtn: 'Sottoscrivi ora',
      applyBox: {
        name: 'Il tuo nome',
        tel: 'Numero di contatto',
        department: 'Dipartimento',
        role: 'Ruolo',
        country: 'Nazione',
        city: 'Città',
        pleaseEnter: 'Per favore inserisci',
        pleaseSelect: 'Per favore seleziona',
        pleaseEnterTheName: 'Per favore inserisci il tuo nome',
        pleaseEnterTheTel: 'Per favore inserisci il tuo numero di contatto',
        pleaseEnterValidTel: 'Per favore inserisci un numero di contatto valido',
        pleaseEnterValidEmail: 'Per favore inserisci una email valida',
        pleaseSelectTheDepartment: 'Per favore seleziona il tuo dipartimento',
        pleaseSelectTheRole: 'Per favore seleziona il tuo ruolo',
        pleaseSelectTheCountry: 'Per favore seleziona la tua nazione',
        pleaseEnterTheCity: 'Per favore inserisci la tua città',
        textIsRequired: 'Questo campo è obbligatorio',
        submit: 'Invia',
        tip: 'Ogni azienda ha solo una opportunità di prova gratuita',
      },
      gotTrial: 'Hai ricevuto una prova!',
      goPc: 'Per favore vai alla versione web di PC per creare il tuo progetto.',
      back: 'Torna indietro',
      country: {
        China: 'Cina',
        Japan: 'Giappone',
        Korea: 'Corea',
        Indonesia: 'Indonesia',
        Thailand: 'Thailandia',
        Singapore: 'Singapore',
        Malaysia: 'Malesia',
        Vietnam: 'Vietnam',
        Germany: 'Germania',
        Britain: 'Regno Unito',
        France: 'Francia',
        Italy: 'Italia',
        Russia: 'Russia',
        Spain: 'Spagna',
        Turkey: 'Turchia',
        America: 'Stati Uniti',
        Canada: 'Canada',
        Brazil: 'Brasile',
        Other: 'Altro',
      },
      department: {
        Brand: 'Marchio',
        Market: 'Mercato',
        Marketing: 'Marketing',
        IT: 'IT',
        Procurement: 'Acquisti',
        Other: 'Altro',
      },
      role: {
        President: 'Presidente/Vicepresidente/Direttore generale',
        CMO: 'CMO o altro dirigente di livello C',
        Director: 'Direttore di dipartimento',
        Manager: 'Responsabile di dipartimento',
        Other: 'Altro',
      },
      message: {
        submitSuccess: 'Invia con successo',
        submitFailed: 'Invia fallito, per favore riprova',
      },
    },
    downloadPptRechargeModal: {
      title: 'Il rapporto non può essere scaricato',
      desc1: 'Nella versione di prova non è possibile scaricare il rapporto',
      desc2: 'Sottoscrivi per ottenere il rapporto completo',
      btn: 'Sottoscrivi ora',
    },
    checkInvitationCodeModal: {
      invitationCode: 'Codice di referral',
      invitationCodeDesc1:
        'Il codice di referral non può essere modificato, per favore contattaci se vuoi modificarlo',
      invitationCodeDesc2:
        'Se stai utilizzando questo tramite un referral di agente, inserisci il codice di referral',
      invitationCodePlaceholder: 'Inserisci il codice di referral',
      invitationCodeError: 'Codice di referral non valido',
      invitationCodeSuccess: 'Codice di referral modificato con successo',
      ok: 'OK',
      cancel: 'Annulla',
    },
    aigcPromotionModal: {
      title: 'Vantaggi Creator AIGC',
      subTitle: 'Registrati ora per ottenere <tmp>5</tmp> opportunità di valutazione video AI',
      desc1: "Partecipa all'evento AdEff AI Creative Testing per valutare i tuoi creativi.",
      desc2: 'Registrati ora e ottieni subito 5 test gratuiti.',
      registerBtn: 'Registrati per ottenere test',
      tip: "Solo per nuovi utenti registrati tramite l'ingresso della campagna Creator AIGC",
      floatTitle: 'Test gratuito',
    },
  },
}

export default TRANSLATION
